import React from 'react';
import { IconClock } from 'takeat-design-system-ui-kit';
import { Container, Time, Title } from './styles';

export default function PreparationTime({
  preparingTime,
  stepTime,
  kanbanType,
}) {
  return (
    <Container type={kanbanType}>
      <IconClock size={20} style={{ flexShrink: 0 }} />
      <Title>Preparo:</Title>
      <Time>{preparingTime}</Time>|<Title>Nessa etapa:</Title>
      <Time>{stepTime}</Time>
    </Container>
  );
}
